import styled from 'styled-components'

export const SideBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  min-width: 192px;
  width: 100%;
`
